<template>
  <div class="indexBg">
    <div class="header">
      <div class="left">
        <div
          class="return"
          :class="{ active: isReturn }"
          @mousedown="handlePressReturn(true)"
          @mouseup="handlePressReturn(false)"
          @mouseleave="handlePressReturn(false)"
          @touchstart="handlePressReturn(true)"
          @touchend="handlePressReturn(false)"
          @touchcancel="handlePressReturn(false)"
          @click="goReturn"
        ></div>
        <div class="questionsNumber">
          <span>{{ currentIndex + 1 }}</span
          >/{{ total }} 题
        </div>
      </div>

      <div class="timeBox">
        <!-- <div class="timeIcon"></div> -->
        <div class="time">{{ formattedTime(totalSeconds) }}</div>
      </div>
    </div>
    <div class="content" v-if="currentQuestion">
      <div class="questionTitle">
        <div>
          <i class="questionTitleIcon">{{
            String(currentIndex + 1).padStart(2, "0")
          }}</i>
        </div>
        <div class="questionTitleText">
          <span class="questionType">
            （{{
              currentQuestion.optionType === "single"
                ? "单选"
                : currentQuestion.optionType === "multiple"
                ? "多选"
                : currentQuestion.optionType === "drag"
                ? "拖拽"
                : ""
            }}）
          </span>

          {{ currentQuestion.title }}
        </div>
      </div>

      <div
        class="questionOption"
        :class="{ 'has-image': currentQuestion.titleImg }"
      >
        <img
          class="titleImg"
          v-if="currentQuestion.titleImg"
          :src="currentQuestion.titleImg"
          alt=""
        />
        <!-- 单选题 -->
        <van-radio-group
          v-if="currentQuestion.optionType === 'single'"
          v-model="userAnswer"
          :disabled="isAnswered"
        >
          <van-radio
            v-for="(item, index) in currentQuestion.contentObj"
            :key="index"
            :name="String(index)"
          >
            <span style="color: #555555" v-if="item.label"
              >{{ item.label }}
              <span style="color: #555555" v-if="item.text || item.img"
                >、</span
              ></span
            >
            <span v-if="item.text" class="optionText">{{ item.text }}</span>
            <img v-if="item.img" class="optionImg" :src="item.img" alt="" />
          </van-radio>
        </van-radio-group>

        <!-- 多选题 -->
        <van-checkbox-group
          v-if="currentQuestion.optionType === 'multiple'"
          v-model="userAnswer"
          :disabled="isAnswered"
        >
          <van-checkbox
            shape="square"
            v-for="(item, index) in currentQuestion.contentObj"
            :key="index"
            :name="String(index)"
          >
            <span style="color: #555555" v-if="item.label"
              >{{ item.label
              }}<span style="color: #555555" v-if="item.text || item.img"
                >、</span
              ></span
            >
            <span v-if="item.text" class="optionText">{{ item.text }}</span>
            <img v-if="item.img" class="optionImg" :src="item.img" alt="" />
          </van-checkbox>
        </van-checkbox-group>

        <!-- 拖拽题 -->
        <div class="drag-question" v-if="currentQuestion.optionType === 'drag'">
          <div class="drag-boxes">
            <!-- A组 -->
            <div class="drag-box">
              <div class="box-title">{{ boxTitleA }}</div>
              <div class="drop-zone">
                <draggable
                  v-for="(_, index) in maxItemsPerCategoryMap[this.boxTitleA]"
                  :key="'A-' + index"
                  :ref="'categoryA-' + index"
                  v-model="categoryA[index]"
                  :group="{ name: 'apps', pull: false, put: true }"
                  class="zone-item"
                  :sort="false"
                  @add="onAddToTarget"
                >
                  <div
                    v-for="item in categoryA[index]"
                    :key="item.cloneId || item.id"
                    class="drag-item drop-item"
                  >
                    <img :src="item.img" />
                    <span>{{ item.text }}</span>
                  </div>
                </draggable>
              </div>
            </div>

            <!-- B组 -->
            <div class="drag-box">
              <div class="box-title">{{ boxTitleB }}</div>
              <div class="drop-zone">
                <draggable
                  v-for="(_, index) in maxItemsPerCategoryMap[this.boxTitleB]"
                  :key="'B-' + index"
                  :ref="'categoryB-' + index"
                  v-model="categoryB[index]"
                  :group="{ name: 'apps', pull: false, put: true }"
                  class="zone-item"
                  :sort="false"
                  @add="onAddToTarget"
                >
                  <div
                    v-for="item in categoryB[index]"
                    :key="item.cloneId || item.id"
                    class="drag-item drop-item"
                  >
                    <img :src="item.img" />
                    <span>{{ item.text }}</span>
                  </div>
                </draggable>
              </div>
            </div>
          </div>

          <!-- 拖拽来源 -->
          <div class="drag-options">
            <draggable
              :list="dragOptions"
              :group="{ name: 'apps', pull: 'clone', put: false }"
              class="drag-source"
              :clone="cloneItem"
              :sort="false"
            >
              <div
                v-for="item in dragOptions"
                :key="item.id"
                class="drag-item"
                :class="{ disabled: usedIds.includes(item.id) }"
                :draggable="!usedIds.includes(item.id)"
                :data-original-id="item.originalId || item.id"
                :data-id="item.id"
              >
                <img :src="item.img" />
                <span>{{ item.text }}</span>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <!-- 正确答案 -->
      <div class="answerBox" v-show="isAnswered" v-if="!isDrawer">
        <div class="wrongTitle wrong" v-if="!isCorrect">
          <img src="@/assets/wrongIcon.png" alt="" />
          正确答案：{{ formattedAnswer }}
        </div>
        <div class="successTitle success" v-else>
          <img src="@/assets/successIcon.png" alt="" />
          正确答案：{{ formattedAnswer }}
        </div>
      </div>

      <!-- 提交按钮 -->
      <div class="btnBox" :class="{ 'has-image': currentQuestion.titleImg }">
        <div
          class="resetBtn"
          :class="{ active: isResetDrag }"
          @mousedown="handlePressResetDrag(true)"
          @mouseup="handlePressResetDrag(false)"
          @mouseleave="handlePressResetDrag(false)"
          @touchstart="handlePressResetDrag(true)"
          @touchend="handlePressResetDrag(false)"
          @touchcancel="handlePressResetDrag(false)"
          @click="resetDrag"
          v-if="currentQuestion.optionType === 'drag' && !isDrawer"
        >
          重选
        </div>
        <div
          class="submitBtn"
          v-if="!isAnswered && !isLastQuestion && !isDrawer"
          @click="handleSubmit"
        >
          提交
        </div>
        <!-- 交卷按钮：仅最后一题且未答题时显示 -->
        <div
          class="nextBtn lastBtn"
          v-if="!isAnswered && isLastQuestion && !isDrawer"
          @click="handleSubmit"
        >
          交卷
        </div>

        <!-- 下一题 / 交卷 倒计时按钮：答题后显示 -->
        <div
          class="nextBtn"
          :class="{ lastBtn: isLastQuestion, disabledBtn: isLastQuestion }"
          v-if="isAnswered && !isDrawer"
          @click="nextQuestion"
        >
          {{ isLastQuestion ? "交卷中..." : "下一题"
          }}<span> {{ countdown }}s</span>
        </div>
      </div>
    </div>

    <!-- 抽屉部分 -->
    <van-popup
      v-model="isDrawer"
      :close-on-click-overlay="false"
      position="bottom"
      round
      class="drawer-popup"
    >
      <div class="drawer-content">
        <!-- 正确答案 -->
        <div
          v-if="currentQuestion.optionType === 'drag'"
          class="answerBox"
          v-show="isAnswered"
        >
          <div
            class="wrongTitle wrong"
            style="flex-direction: column"
            v-if="!isCorrect"
          >
            <div style="margin-bottom: 10px">
              <img src="@/assets/wrongIcon.png" alt="" /> 正确答案：
            </div>
            <div>{{ formattedAnswer }}</div>
          </div>
          <div
            class="successTitle success"
            style="flex-direction: column"
            v-else
          >
            <div style="margin-bottom: 10px">
              <img src="@/assets/successIcon.png" alt="" /> 正确答案：
            </div>
            <div>{{ formattedAnswer }}</div>
          </div>
        </div>
        <div v-else class="answerBox" v-show="isAnswered">
          <div class="wrongTitle wrong" v-if="!isCorrect">
            <img src="@/assets/wrongIcon.png" alt="" />
            正确答案：{{ formattedAnswer }}
          </div>
          <div class="successTitle success" v-else>
            <img src="@/assets/successIcon.png" alt="" />
            正确答案：{{ formattedAnswer }}
          </div>
        </div>

        <!-- 下一题 / 交卷 倒计时按钮：答题后显示 -->
        <div
          class="nextBtn"
          :class="{ lastBtn: isLastQuestion, disabledBtn: isLastQuestion }"
          v-if="isAnswered"
          @click="nextQuestion"
        >
          {{ isLastQuestion ? "交卷中..." : "下一题"
          }}<span> {{ countdown }}s</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { getPublic, orgtest } from '@/api/index'
import sceneManager from '@/utils/sceneManager'
export default {
  name: 'evaluationPage',
  components: {
    draggable
  },
  data () {
    return {
      isReturn: false,
      isDrawer: false,
      isResetDrag: false,

      minute: 0, // 分钟数
      second: 0, // 秒数
      totalSeconds: 0, // 总秒数
      serialNumber: 0, // 当前题目序号
      total: 0, // 总题数
      timer: null, // 定时器引用
      startTime: null, // 记录开始时间
      evaluationStartTimestamp: null,
      optionType: '单选', // 题目类型
      optionTitle: '', // 题目标题
      radio: '', // 单选框选中值
      options: [], // 接收传入的所有题目
      currentIndex: 0, // 当前题目数
      totalScore: 0,
      userAnswer: [],
      isAnswered: false,
      content: [],
      isCorrect: false,
      formattedAnswer: '',
      countdown: 3,
      countdownTimer: null,
      questionStartTimestamp: null,
      orgId: 1,
      deviceCode: '',
      testId: '',
      testCode: '',
      questionAudio: null,

      // 拖拽题特有的数据
      dragOptions: [], // 可拖拽选项
      categoryA: [], // A组
      categoryB: [], // B组
      usedIds: [], // 已使用的选项ID
      boxTitleA: '', // A组标题
      boxTitleB: '', // B组标题
      maxItemsPerCategoryMap: {} // 每个类别允许的最大项目数
    }
  },
  computed: {
    // 计算总用时（秒）
    totalTime () {
      return this.minute * 60 + this.second
    },
    currentQuestion () {
      return this.options[this.currentIndex]
    },
    isLastQuestion () {
      return this.currentIndex === this.options.length - 1
    }
  },
  watch: {
    currentQuestion: {
      immediate: true, // 组件初始化时也执行一次
      handler (newQuestion) {
        if (!newQuestion) return

        this.questionStartTimestamp = Date.now()
        this.playQuestionAudio(newQuestion.optionId)

        // 设置初始答案结构
        this.userAnswer = newQuestion.optionType === 'multiple' ? [] : ''

        if (newQuestion.optionType === 'drag') {
          // 解析可拖拽选项
          console.log('解析可拖拽选项：', newQuestion.contentObj)

          this.dragOptions = newQuestion.contentObj.map((item, index) => ({
            ...item,
            id: index,
            originalId: index
          }))
          console.log('拖拽选项：', this.dragOptions)

          // 解析正确答案分组
          const correctAnswer = JSON.parse(newQuestion.answer)
          const keys = Object.keys(correctAnswer)
          this.boxTitleA = keys[0]
          this.boxTitleB = keys[1]

          // 保存每组允许的最大数量

          Object.entries(correctAnswer).forEach(([key, val]) => {
            this.maxItemsPerCategoryMap[key] = val.length
          })
          this.initCategoryBoxes()

          // 重置状态
          this.usedIds = []
        }
      }
    }
  },

  created () {
    sceneManager.reset()
    this.startTimer()
    // 获取 deviceCode：正式环境从 URL 获取，测试环境使用固定值
    const urlParams = new URLSearchParams(window.location.search)
    const deviceCodeFromUrl = urlParams.get('deviceCode')
    const deviceCode = deviceCodeFromUrl || 'a034e84a93526854' // 测试环境默认值
    this.deviceCode = deviceCode

    // 调用 getPublic 接口，传递 deviceCode
    this.getPublic(deviceCode)
  },
  mounted () {
    const deviceCode = this.$store.getters.getDeviceCode
    const testId = this.$store.getters.getTestId
    console.log('deviceCode:', deviceCode)
    console.log('testId:', testId)
  },

  beforeDestroy () {
    // 组件销毁前清除定时器
    this.clearTimer()
    this.clearQuestionAudio()
  },

  methods: {
    playQuestionAudio (optionId) {
      this.clearQuestionAudio()
      if (!optionId && optionId !== 0) return
      try {
        const audioSrc = require(`@/assets/music/evaluation/${optionId}.mp3`)
        const audio = new Audio(audioSrc)
        audio.play().catch((err) => {
          console.log(
            `Question audio play failed for optionId ${optionId}:`,
            err
          )
        })
        this.questionAudio = audio
      } catch (err) {
        console.log(`Question audio not found for optionId ${optionId}:`, err)
      }
    },
    clearQuestionAudio () {
      if (this.questionAudio) {
        try {
          this.questionAudio.pause()
          this.questionAudio.currentTime = 0
        } catch (err) {
          console.log('Failed to reset question audio:', err)
        }
        this.questionAudio = null
      }
    },
    initCategoryBoxes () {
      const correctAnswer = JSON.parse(this.currentQuestion.answer)
      const countA = correctAnswer[this.boxTitleA].length
      const countB = correctAnswer[this.boxTitleB].length

      this.categoryA = Array.from({ length: countA }, () => [])
      this.categoryB = Array.from({ length: countB }, () => [])
    },
    onAddToTarget (evt) {
      const toListA = this.categoryA
      const toListB = this.categoryB

      toListA.forEach((itemIndex) => {
        console.log('拖入 A 组的项：', itemIndex)
        if (itemIndex.length > 1) {
          itemIndex.splice(0, itemIndex.length - 1)
          this.$toast('每个框只能放一个选项')
        }
        if (itemIndex[0]) {
          this.usedIds.push(itemIndex[0].id)
        }
      })
      toListB.forEach((itemIndex) => {
        console.log('拖入 A 组的项：', itemIndex)
        if (itemIndex.length > 1) {
          itemIndex.splice(0, itemIndex.length - 1)
          this.$toast('每个框只能放一个选项')
        }
        if (itemIndex[0]) {
          this.usedIds.push(itemIndex[0].id)
        }
      })
    },

    // 克隆拖拽项
    cloneItem (item) {
      if (this.usedIds.includes(item.id)) {
        this.$toast('该选项已使用')
        return
      }
      return {
        ...item,
        cloneId: `${item.id}-${Date.now()}`,
        originalId: item.id
      }
    },
    // 检查答案
    checkDragAnswer () {
      const correctAnswer = JSON.parse(this.currentQuestion.answer)
      const extractIds = (category) => {
        return category.map((box) => (box[0] ? box[0].originalId : null))
      }
      // 提取用户答案
      const userAnswer = {
        [this.boxTitleA]: extractIds(this.categoryA),
        [this.boxTitleB]: extractIds(this.categoryB)
      }
      // 检查每个组的答案是否正确
      const isCorrect =
        JSON.stringify(userAnswer) === JSON.stringify(correctAnswer)

      return isCorrect
    },
    // 重置所有拖拽内容
    resetDrag () {
      this.usedIds = []
      this.initCategoryBoxes()
    },

    // 格式化拖拽题答案显示
    formatDragAnswer (answer) {
      const ans = JSON.parse(answer)

      const options = this.currentQuestion.contentObj

      const formatGroup = (group) => {
        return group.map((index) => options[index]?.text).join('、')
      }

      // 动态解析每一组
      const result = Object.entries(ans)
        .map(([groupTitle, indexes]) => {
          return `${groupTitle}：${formatGroup(indexes)}`
        })
        .join('\n') //  使用换行分隔每组

      return result
    },
    formatAnswer (answer) {
      const map = ['A', 'B', 'C', 'D']
      return answer
        .split(',')
        .map((i) => map[parseInt(i)])
        .join('、')
    },
    startCountdown (callback) {
      this.countdown = 3
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--
        } else {
          clearInterval(this.countdownTimer)
          callback()
        }
      }, 1000)
    },

    goReturn () {
      this.$dialog
        .confirm({
          title: '提示',
          message: '是否退出本次测评？'
        })
        .then(() => {
          // on confirm
          // this.$router.go(-1) // 返回上一页
          this.$router.replace('/')
        })
        .catch(() => {
          // on cancel
        })
    },
    handlePressReturn (state) {
      this.isReturn = state
    },
    handlePressResetDrag (state) {
      this.isResetDrag = state
    },
    playSuccessSound () {
      try {
        const audio = new Audio(require('@/assets/music/success.mp3'))
        audio.play().catch((e) => console.log('Audio play failed:', e))
      } catch (e) {
        console.log('Success sound not found or failed:', e)
      }
    },
    playFailSound () {
      try {
        const audio = new Audio(require('@/assets/music/fail.mp3'))
        audio.play().catch((e) => console.log('Audio play failed:', e))
      } catch (e) {
        console.log('Fail sound not found or failed:', e)
      }
    },
    getPublic (deviceCode) {
      getPublic(deviceCode).then((res) => {
        this.total = res.data.data.options.length
        this.options = res.data.data.options
        this.orgId = res.data.data.orgId || 1
        this.testId = res.data.data.testId || ''
        this.testCode = res.data.data.testCode || ''
        if (deviceCode || this.testId) {
          this.$store.dispatch('updateDeviceInfo', {
            deviceCode,
            testId: this.testId
          })
        }
        this.userAnswer = this.options[0].optionType === 'multiple' ? [] : ''
        if (this.currentQuestion.optionType === 'drag') {
          // 解析可拖拽选项
          this.dragOptions = this.currentQuestion.contentObj.map(
            (item, index) => ({
              ...item,
              id: index, // 使用索引作为唯一ID
              originalId: index // 原始ID用于跟踪
            })
          )

          // 解析正确答案分组
          const correctAnswer = JSON.parse(this.currentQuestion.answer)
          const keys = Object.keys(correctAnswer)
          this.boxTitleA = keys[0]
          this.boxTitleB = keys[1]

          // 重置状态
          this.categoryA = []
          this.categoryB = []
          this.usedIds = []
        }
        if (this.options.length && this.options[0].optionType === 'scene') {
          this.enterSceneFlow(0)
        }
      })
    },
    // 格式化显示时间
    formattedTime (totalSeconds) {
      const seconds = totalSeconds % 60
      const minutes = Math.floor((totalSeconds / 60) % 60)
      const hours = Math.floor((totalSeconds / 3600) % 24)
      const days = Math.floor(totalSeconds / 86400)

      if (totalSeconds < 3600) {
        // 小于 1 小时 → 分秒
        return `${minutes.toString().padStart(2, '0')}分 ${seconds
          .toString()
          .padStart(2, '0')}秒`
      } else if (totalSeconds < 86400) {
        // 小于 1 天 → 时分秒
        return `${hours.toString().padStart(2, '0')}时 ${minutes
          .toString()
          .padStart(2, '0')}分 ${seconds.toString().padStart(2, '0')}秒`
      } else {
        // 大于等于 1 天 → 天时分秒
        return `${days}天 ${hours.toString().padStart(2, '0')}时 ${minutes
          .toString()
          .padStart(2, '0')}分 ${seconds.toString().padStart(2, '0')}秒`
      }
    },

    // 开始计时
    startTimer () {
      this.startTime = new Date() // 记录开始时间
      this.evaluationStartTimestamp = this.startTime.getTime()
      window.__evaluationStartTimestamp = this.evaluationStartTimestamp
      window.__evaluationElapsedSeconds = 0
      this.timer = setInterval(() => {
        this.second++
        if (this.second === 60) {
          this.second = 0
          this.minute++
        }
        this.totalSeconds = this.minute * 60 + this.second
        window.__evaluationElapsedSeconds = this.totalSeconds
      }, 1000)
    },
    // 清除定时器
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    onChange (value) {
      this.radio = value
    },

    getCurrentUseTime () {
      if (!this.questionStartTimestamp) return 0
      return Math.floor((Date.now() - this.questionStartTimestamp) / 1000)
    },

    // 提交
    handleSubmit () {
      if (this.isAnswered) return

      const type = this.currentQuestion.optionType
      const useTime = this.getCurrentUseTime()

      if (type === 'single' || type === 'multiple') {
        // 检查是否选择了答案
        if (
          (type === 'single' && this.userAnswer === '') ||
          (type === 'multiple' && this.userAnswer.length === 0)
        ) {
          this.$toast('请选择答案')
          return
        }

        const correctAnswer = this.currentQuestion.answer
          .split(',')
          .sort()
          .join(',')
        const reply = Array.isArray(this.userAnswer)
          ? this.userAnswer.sort().join(',')
          : this.userAnswer

        this.isCorrect = correctAnswer === reply
        const score = this.isCorrect ? this.currentQuestion.score : 0
        if (this.isCorrect) this.totalScore += score
        if (this.isCorrect) {
          this.playSuccessSound()
        } else {
          this.playFailSound()
        }

        this.formattedAnswer = this.formatAnswer(correctAnswer)

        this.content.push({
          title: this.currentQuestion.title,
          sort: this.currentQuestion.sort,
          optionId: this.currentQuestion.optionId,
          optionType: type,
          dimCode: this.currentQuestion.dimCode || '',
          answer: this.currentQuestion.answer,
          reply,
          validity: this.isCorrect ? 1 : 0,
          score,
          useTime
        })
      } else if (type === 'drag') {
        // 检查 this.categoryA 或 this.categoryB 是否有有效数据（子数组长度 > 0）
        const answerFilledA = this.categoryA.some(
          (itemIndex) => itemIndex.length > 0
        )
        const answerFilledB = this.categoryB.some(
          (itemIndex) => itemIndex.length > 0
        )
        const answerFilled = answerFilledA || answerFilledB

        if (!answerFilled) {
          this.$toast('请拖入答案后再提交')
          return
        }

        this.isCorrect = this.checkDragAnswer()
        const score = this.isCorrect ? this.currentQuestion.score : 0
        if (this.isCorrect) this.totalScore += score
        if (this.isCorrect) {
          this.playSuccessSound()
        } else {
          this.playFailSound()
        }

        this.formattedAnswer = this.formatDragAnswer(
          this.currentQuestion.answer
        )

        this.content.push({
          title: this.currentQuestion.title,
          sort: this.currentQuestion.sort,
          optionId: this.currentQuestion.optionId,
          optionType: type,
          dimCode: this.currentQuestion.dimCode || '',
          answer: this.currentQuestion.answer,
          reply: JSON.stringify({
            [this.boxTitleA]: this.categoryA
              .flat()
              .map((item) => item.originalId),
            [this.boxTitleB]: this.categoryB
              .flat()
              .map((item) => item.originalId)
          }),
          validity: this.isCorrect ? 1 : 0,
          score,
          useTime
        })
      }

      this.isAnswered = true
      if (
        this.currentQuestion.titleImg ||
        this.currentQuestion.optionType === 'drag'
      ) {
        this.isDrawer = true
        this.startCountdown(() => {
          this.isLastQuestion ? this.submitAll() : this.nextQuestion()
        })
      } else {
        this.startCountdown(() => {
          this.isLastQuestion ? this.submitAll() : this.nextQuestion()
        })
      }
    },

    // 跳转下一题
    nextQuestion () {
      if (this.isLastQuestion) return // 如果是最后一题则不触发
      clearInterval(this.countdownTimer)
      const nextIndex = this.currentIndex + 1
      const nextQuestion = this.options[nextIndex]
      if (nextQuestion && nextQuestion.optionType === 'scene') {
        this.enterSceneFlow(nextIndex)
        return
      }
      this.isAnswered = false
      this.isCorrect = false
      this.formattedAnswer = ''
      this.countdown = 3
      this.currentIndex = nextIndex
      this.userAnswer =
        this.currentQuestion.optionType === 'multiple' ? [] : ''
      if (this.currentQuestion.optionType === 'drag') {
        this.categoryA = []
        this.categoryB = []
        this.usedIds = []
      }
      this.isDrawer = false
    },
    // 最后提交数据
    submitAll () {
      this.isDrawer = false
      this.clearQuestionAudio()
      const useTime = this.totalTime
      const testId = this.testId || this.$store.getters.getTestId
      const deviceCode = this.deviceCode || this.$store.getters.getDeviceCode
      const testCode = this.testCode || ''
      const payload = {
        testId,
        deviceCode,
        testCode,
        totalScore: this.totalScore,
        useTime,
        content: JSON.stringify(this.content)
      }
      console.log(this.content, 'this.content')

      orgtest(payload).then((res) => {
        console.log(res, '提交数据：')
      })
      const successCount = this.content.filter((item) => {
        const reply = item.reply.split(',').sort().join(',')
        const answer = item.answer.split(',').sort().join(',')
        return reply === answer
      }).length

      const totalCount = this.content.length
      this.$router.push({
        path: '/result',
        query: {
          totalScore: this.totalScore,
          useTime: this.totalTime,
          successCount,
          totalCount
        }
      })
      // TODO: 替换为实际提交 API
      // axios.post('/submit', payload).then(...)
    },
    enterSceneFlow (startIndex) {
      this.isAnswered = false
      this.isCorrect = false
      this.formattedAnswer = ''
      this.isDrawer = false
      const sceneQuestions = this.options.slice(startIndex)
      const context = {
        content: this.content.slice(),
        totalScore: this.totalScore,
        deviceCode: this.deviceCode || this.$store.getters.getDeviceCode,
        testId: this.testId || this.$store.getters.getTestId,
        testCode: this.testCode || '',
        orgId: this.orgId,
        startTimestamp:
          this.evaluationStartTimestamp ||
          Date.now() - (this.totalSeconds || 0) * 1000
      }
      window.__evaluationStartTimestamp = context.startTimestamp
      window.__evaluationElapsedSeconds = this.totalSeconds
      sceneManager.initialize(sceneQuestions, context)
      const introRoute = sceneManager.getCurrentIntroRoute()
      if (introRoute) {
        this.$router.replace({
          name: introRoute
        })
      } else {
        this.submitAll()
      }
      this.clearQuestionAudio()
    }
  }
}
</script>

<style scoped lang="less">
.indexBg {
  width: 100%;
  height: 100vh;
  background: linear-gradient(
    180deg,
    rgba(58, 177, 255, 1),
    rgba(238, 238, 238, 1) 25%
  );
}
.header {
  position: absolute;
  top: 20px;
  // left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-family: Alibaba-PuHuiTi-Regular;

  .left {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .return {
      width: 80px;
      height: 80px;
      background: url("@/assets/return.png") no-repeat center / 100% 100%;
      margin-right: 50px;
      // margin-left: 20px;
    }
    .return.active {
      background: url("@/assets/returnOver.png") no-repeat center / 100% 100%;
    }
    .questionsNumber {
      display: flex;
      align-items: flex-end;
      font-size: 43px;
      color: #fff;
      span {
        color: #fbf741;
      }
    }
  }

  .timeBox {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-radius: 50px;
    border-radius: 67.5px;
    background: rgba(255, 255, 255, 1);
    opacity: 0.8;
    color: #326edc;
    font-size: 43px;
    margin-right: 20px;
    // .timeIcon {
    //   width: 50px;
    //   height: 50px;
    //   background: url("@/assets/time.png") no-repeat center / 100% 100%;
    //   margin-right: 30px;
    // }
  }
}
.content {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translate(-50%);
  background-color: #fff;
  width: 90%;
  min-height: 85%;
  max-height: 100%;
  // overflow-y: auto;
  border-radius: 20px;
  padding: 20px;
  font-family: Alibaba-PuHuiTi-Regular;
  font-size: 40px;
  .questionTitle {
    display: flex;
    padding-bottom: 30px;
    border-bottom: 2px solid rgba(206, 206, 206, 1);
    .questionTitleIcon {
      color: #fff;
      padding: 0px 20px;
      font-style: normal;
      border-radius: 33px;
      margin-right: 10px;
      background: linear-gradient(
        90deg,
        rgba(245, 118, 41, 1),
        rgba(255, 176, 129, 1) 100%
      );
    }
    .questionTitleText {
      position: relative;
      text-indent: 3em;
      font-weight: 700;
    }
    .questionType {
      position: absolute;
      left: -3.5em;
      color: #f5683a;
    }
  }
  .titleImg {
    width: 100%;
    //  margin: 0 auto;
    // margin-top: 20px;
  }
  .questionOption {
    margin-top: 20px;
    // padding-bottom: 30px;
    // border-bottom: 2px solid rgba(206, 206, 206, 1);

    &.has-image {
      border-bottom: none;
      ::v-deep .van-radio-group {
        display: flex;
        justify-content: space-around;
      }
      ::v-deep .van-radio {
        margin-left: 0px;
      }
      ::v-deep .van-radio__icon {
        margin: 10px 0 0px 20px;
      }
    }
    ::v-deep .van-radio,
    .van-checkbox {
      min-height: 60px;
    }
    ::v-deep .van-radio__label {
      margin-left: 0px !important;
      line-height: normal !important;
    }
    ::v-deep .van-radio__label {
      // display: flex;
      // align-items: flex-start;
      color: #555555;
      line-height: normal;
      margin-left: 0px;
    }
    ::v-deep .van-checkbox__label {
      display: flex;
      align-items: flex-start;
      color: #555555;
      line-height: normal;
      margin-left: 15px;
    }
    ::v-deep .van-radio__icon {
      margin: 10px 20px 0px 20px;
    }
    ::v-deep .van-checkbox__icon {
      margin: 10px 0px 0px 0px;
    }
    ::v-deep .van-radio {
      margin-bottom: 30px;
      // margin-left: 20px;
      align-items: flex-start;
    }
    ::v-deep .van-checkbox {
      margin-bottom: 20px;
      margin-left: 20px;
      display: flex;
      align-items: flex-start;
    }

    .optionText {
      // margin-right: 20px;
      color: #555555;
    }
    .optionImg {
      height: 60px;
      vertical-align: middle;
    }
  }
}
/* 新增抽屉样式 */
.drawer-popup {
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}

.drawer-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 60px;
  .nextBtn {
    display: flex;
    margin: 0 auto;
    margin-top: 40px;
    align-items: center;
    justify-content: space-evenly;
  }
}

.answerBox {
  padding: 12px 30px 0px 30px;
  .wrongTitle,
  .successTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 90px;
    font-size: 40px;
    width: 100%;
    border-radius: 20px;
    white-space: pre-line;
    padding: 10px 0;
    img {
      width: 50px;
      height: 50px;
      margin-right: 20px;
      vertical-align: bottom;
    }
  }
  .wrong {
    color: rgba(255, 58, 58, 1);
    background: rgba(255, 236, 229, 1);
  }
  .success {
    color: rgba(0, 150, 43, 1);
    background: rgba(219, 255, 222, 1);
  }
}
.btnBox {
  display: flex;
  margin: 0 auto;
  margin-top: 40px;
  align-items: center;
  justify-content: space-around;
  &.has-image {
    margin-top: 0px;
  }
}
.submitBtn {
  width: 320px;
  height: 80px;
  font-family: Alibaba-PuHuiTi-Regular;
  font-size: 40px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("@/assets/submit.png") no-repeat center / 100% 100%;
}
.nextBtn {
  width: 320px;
  height: 80px;
  font-family: Alibaba-PuHuiTi-Regular;
  font-size: 40px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  background: url("@/assets/nextBtn.png") no-repeat center / 100% 100%;
  span {
    margin-left: 10px;
    font-size: 35px;
  }
}
.lastBtn {
  background: url("@/assets/lastBtn.png") no-repeat center / 100% 100%;
}

.drag-question {
  margin-top: 20px;
}
.drag-boxes {
  display: flex;
  justify-content: space-between;
}
.drag-box {
  width: 47%;
  background: #f8f8f8;
  border: 4px solid rgba(145, 196, 255, 1);
  border-radius: 15px;
  min-height: 200px;
}
.box-title {
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
  background-color: #e8f0ff;
  padding: 20px;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}
.drop-zone {
  min-height: 200px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px 20px;
  flex-wrap: wrap;
  padding: 10px;
  .zone-item {
    width: 85px;
    height: 85px;
    box-sizing: border-box;
    border: 2px dashed rgba(145, 196, 255, 1);
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  // gap: 20px;
  .drag-item {
    width: 81px;
    height: 81px;
    text-align: center;
    border-radius: 10px;
    background: #eeeeee;
    box-shadow: 0 0px 0px rgba(0, 0, 0, 0.1);
    // margin-right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .drag-item img {
    width: 40px;
    height: 40px;
  }
  .drag-item span {
    display: block;
    margin-top: 5px;
    font-size: 21px;
  }
}
.drag-options {
  margin-top: 30px;
  background: #fff;
  border-radius: 15px;
  // padding: 20px;
  // display: flex;
  // justify-content: center;
  // flex-wrap: wrap;
  // gap: 10px;
  // border: 2px solid #ccc;
}
.drag-source {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  justify-content: space-around;
}
.drag-item {
  width: 120px;
  height: 120px;
  text-align: center;
  border-radius: 10px;
  background: #eeeeee;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.drag-item.disabled {
  opacity: 0.5;
  pointer-events: none;
  background-color: #838383;
  cursor: not-allowed;
}
.drag-item img {
  width: 60px;
  height: 60px;
}
.drag-item span {
  display: block;
  margin-top: 5px;
  font-size: 26px;
}
.drag-buttons {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin-top: 30px;
}
.resetBtn {
  width: 180px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-size: 40px;
  color: #fff;
  background: url("@/assets/resetDrag.png") no-repeat center / 100% 100%;
}
.resetBtn.active {
  color: #c2c2c2;
  background: url("@/assets/resetDragOver.png") no-repeat center / 100% 100%;
}
</style>
